// Site service-profile (1:1) intent. Mirrors backend ServiceProfileIn/Out in
// api/v1/site_services.py. PUT is patch-like; all fields optional server-side.

export type SupportScope = "managed" | "co_managed" | "unmanaged";

export interface ServiceProfileIn {
  homeassistant_enabled?: boolean;
  frigate_enabled?: boolean;
  mosquitto_enabled?: boolean;
  go2rtc_enabled?: boolean;
  solar_enabled?: boolean;
  custom_connectors?: string[];
  support_scope?: SupportScope | null;
  orixen_support_required?: boolean;
  special_constraints?: string[];
  notes?: string[];
  vendor_extras?: Record<string, unknown>;
}
export interface ServiceProfileConfig extends ServiceProfileIn {
  site_id: string;
}

export const SUPPORT_SCOPES: ReadonlyArray<{ value: SupportScope; label: string }> = [
  { value: "managed", label: "Managed" },
  { value: "co_managed", label: "Co-managed" },
  { value: "unmanaged", label: "Unmanaged" },
];
